export default "__VITE_ASSET__BhXo7Ka0__"